import axios from "axios";

// Публичное API сервера: телефоны в наличии, контакты, расчёт рассрочки
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL + "/public", timeout: 15000 });

const FILES_ORIGIN = (() => {
    try { return new URL(process.env.REACT_APP_API_URL).origin; } catch { return ""; }
})();
export const fileUrl = (p) => (!p ? null : /^https?:/.test(p) ? p : FILES_ORIGIN + p);
export const num = (n) => Math.round(Number(n) || 0).toLocaleString("ru-RU");
export const telHref = (phone) => "tel:" + String(phone || "").replace(/[^\d+]/g, "");

// Допустимый аванс: проценты приходят с сервера (/public/info), берутся из таблицы settings.
// Расчёт тот же, что на сервере
export const advRange = (price, info) => {
    const minPct = info?.minAdvancePct ?? 30, maxPct = info?.maxAdvancePct ?? 80;
    const max = Math.floor((price * maxPct) / 100 / 100000) * 100000;
    const min = Math.min(max, Math.ceil((price * minPct) / 100 / 100000) * 100000);
    return { min, max };
};

export default api;
